import { GenericColumns } from '../Generic/Columns';

export const MaintenanceColumns = [...GenericColumns];
